import { __rest } from "tslib";
import { AnalyticsPromoteEndpoint, AnalyticsPromoteSrc, ElementsClick, } from './consts';
export const checkLightboxLink = (link) => 'linkPopupId' in link;
export const checkIsTopBottomLink = (link) => 'anchorDataId' in link &&
    (link.anchorDataId === 'SCROLL_TO_TOP' ||
        link.anchorDataId === 'SCROLL_TO_BOTTOM');
export const extractPageLinkId = (link, metadata) => {
    var _a;
    if (checkLightboxLink(link)) {
        return link.linkPopupId;
    }
    else {
        const pageUrl = new URL((_a = link.href) !== null && _a !== void 0 ? _a : '');
        const entries = (metadata === null || metadata === void 0 ? void 0 : metadata.pagesMap) && Object.entries(metadata === null || metadata === void 0 ? void 0 : metadata.pagesMap);
        let entry = entries === null || entries === void 0 ? void 0 : entries.find(([pageUriSEO]) => { var _a; return (_a = pageUrl.pathname) === null || _a === void 0 ? void 0 : _a.includes(pageUriSEO); });
        // empty page in pathname - find main page entry
        if (!entry) {
            entry = entries === null || entries === void 0 ? void 0 : entries.find(([, { id }]) => id === (metadata === null || metadata === void 0 ? void 0 : metadata.mainPageId));
        }
        return entry === null || entry === void 0 ? void 0 : entry[1].id;
    }
};
export const extractAnalyticsClicksActionName = (link) => {
    if (link === undefined) {
        return undefined;
    }
    return link === null ? 'None' : link.type;
};
export const createAnalyticsClicksCommonParams = () => ({
    bl: navigator.language,
    url: window.location.href,
});
export const createAnalyticsClicksDetails = (link, metadata) => {
    var _a;
    if (!(link === null || link === void 0 ? void 0 : link.type)) {
        return undefined;
    }
    const { type } = link;
    switch (type) {
        case 'AnchorLink':
            return !checkIsTopBottomLink(link)
                ? { id: link.anchorDataId }
                : undefined;
        case 'DocumentLink':
            return { id: (_a = link.docInfo) === null || _a === void 0 ? void 0 : _a.docId };
        case 'PageLink':
            return {
                id: extractPageLinkId(link, metadata),
                isLightbox: checkLightboxLink(link),
            };
        default:
            return undefined;
    }
};
export const createAnalyticsClicksValue = (link, metadata) => {
    var _a, _b, _c;
    if (!(link === null || link === void 0 ? void 0 : link.type)) {
        return undefined;
    }
    const { type } = link;
    switch (type) {
        case 'AnchorLink':
            return link.anchorDataId;
        case 'DocumentLink':
            return (_a = link.docInfo) === null || _a === void 0 ? void 0 : _a.name;
        case 'PageLink':
            const checkId = extractPageLinkId(link, metadata);
            return (_c = Object.values((_b = metadata === null || metadata === void 0 ? void 0 : metadata.pagesMap) !== null && _b !== void 0 ? _b : {}).find(({ id }) => id === checkId)) === null || _c === void 0 ? void 0 : _c.title;
        default:
            return link.href;
    }
};
export const tryReportAnalyticsClicksBi = (reportBi, params, context) => {
    const { link, value, details, actionName, elementType, pagesMetadata, shouldReportAnalyticsElementsClicks } = params, restParams = __rest(params, ["link", "value", "details", "actionName", "elementType", "pagesMetadata", "shouldReportAnalyticsElementsClicks"]);
    if (!shouldReportAnalyticsElementsClicks) {
        return;
    }
    const linkDetails = createAnalyticsClicksDetails(link, pagesMetadata);
    const biParamsDetails = details || linkDetails
        ? JSON.stringify(Object.assign(Object.assign({}, linkDetails), details))
        : undefined;
    const biParams = Object.assign(Object.assign(Object.assign({}, restParams), createAnalyticsClicksCommonParams()), { details: biParamsDetails, elementType: elementType !== null && elementType !== void 0 ? elementType : 'Unknown', actionName: actionName !== null && actionName !== void 0 ? actionName : extractAnalyticsClicksActionName(link), value: value !== null && value !== void 0 ? value : createAnalyticsClicksValue(link, pagesMetadata) });
    reportBi(Object.assign({ src: AnalyticsPromoteSrc, evid: ElementsClick }, biParams), Object.assign({ endpoint: AnalyticsPromoteEndpoint }, context));
};
//# sourceMappingURL=utils.js.map